module.exports = __webpack_public_path__ + "img/bg8.b23cc2b8.jpg";